module.exports = __webpack_public_path__ + "img/img_brand1.a0c6535b.jpg";